module.exports = __webpack_public_path__ + "static/img/主图2-3.299a1a6a.png";